import CartDeliverySkeleton from '@page-components/Order/CartV3/CartContent/CartDelivery/Skeleton'

import UserMenuSkeleton from './UserMenu/Skeleton'
import WebsiteCoinsSkeleton from './WebsiteCoins/Skeleton'

function NavbarSkeleton() {
  return (
    <>
      <div className="relative inset-0 z-[250] sticky bg-gray-200 dark:bg-zinc-800 text-gray-400">
        <div className="mx-auto flex flex-row justify-between items-center p-4 md:p-5 max-w-[100dw] md:max-w-[1200px]">
          <div className="flex items-center space-x-4 md:space-x-5">
            <div className="text-2xl">
              <div className="w-12 h-12 bg-gray-100 dark:bg-zinc-600 rounded-md animate-pulse" />
            </div>
            <div className="w-36 h-12 bg-gray-100 dark:bg-zinc-600 rounded-md animate-pulse" />
          </div>
          <div className="flex items-center justify-between space-x-3">
            <div className="flex-1 h-12 w-80 hidden md:flex">
              <CartDeliverySkeleton />
            </div>
            <WebsiteCoinsSkeleton />
            <UserMenuSkeleton />
            <div className="w-20 h-12 bg-gray-100 dark:bg-zinc-600 rounded-md animate-pulse hidden md:flex" />
          </div>
        </div>
      </div>
    </>
  )
}

export default NavbarSkeleton
